import { useEffect, useState } from "react";
import useSWR from "swr";

const Advertisement = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [combinedMedia, setCombinedMedia] = useState<
    (string | { type: string; src: string })[]
  >([]);

  const { data: advertisementData } = useSWR(["/v1/thaihealth/advertisement/"]);

  useEffect(() => {
    if (advertisementData) {
      const videos = advertisementData.videos.map((video: string) => ({
        type: "video",
        src: video,
      }));
      const images = advertisementData.images.map((image: string) => ({
        type: "image",
        src: image,
      }));

      // Combine both arrays
      setCombinedMedia([...videos, ...images]);
    }
  }, [advertisementData]);

  useEffect(() => {
    if (combinedMedia.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % combinedMedia.length);
      }, 20000); // 20 seconds

      return () => clearInterval(interval); // Clear interval on component unmount
    }
  }, [combinedMedia]);

  // Render based on the current media item (video or image)
  const currentMedia: any = combinedMedia[currentIndex];

  return (
    <div className="h-full w-full relative">
      {currentMedia?.type === "video" ? (
        <iframe
          width="100%"
          height="100%"
          src={`${currentMedia.src}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      ) : (
        <img
          src={currentMedia?.src}
          alt="Advertisement"
          style={{
            width: "100%",
            height: "1000px",
            marginTop: "12px",
            objectFit: "contain",
            objectPosition: "center",
          }}
        />
      )}
    </div>
  );
};

export default Advertisement;
